import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Login.css';
import { AuthContext } from './../AuthContext';
import api from '../api';

const Register = () => {
  const { login } = useContext(AuthContext);

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await api.post('/auth/register', {
        username,
        email,
        first_name: firstName || null,
        last_name: lastName || null,
        password,
      });

      const token = response.data.access_token;
      if (token) {
        login(token);
      } else {
        setError('Registration failed');
      }
    } catch (err) {
      console.error('Error registering:', err);
      setError('Registration failed. Please check your inputs.');
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Register</h2>
        {error && <p className="error-message">{error}</p>}

        <label>
          Username:
          <input value={username} onChange={(e) => setUsername(e.target.value)} required />
        </label>

        <label>
          Email:
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>

        <label>
          First name:
          <input value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        </label>

        <label>
          Last name:
          <input value={lastName} onChange={(e) => setLastName(e.target.value)} />
        </label>

        <label>
          Password:
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>

        <button type="submit">Create account</button>

        <div style={{ marginTop: 12 }}>
          <Link to="/login">Back to login</Link>
        </div>
      </form>
    </div>
  );
};

export default Register;
